<template>
  <v-tour
    name="myTour"
    :steps="steps"
    :callbacks="myCallbacks"
    v-if="$route.name === 'suspicious-traffic' && steps.length"
  >
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-for="(step, index) of tour.steps"
          v-if="tour.currentStep === index"
          :key="index"
          :step="step"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
        >
          <template>
            <div slot="header" class="header">
              <div v-if="tour.currentStep === 0">
                Welcome tour
              </div>
              <div v-if="tour.currentStep === 1">
                Select your Network
              </div>
              <div v-if="tour.currentStep === 2">
                Select period of time
              </div>
              <div v-if="tour.currentStep === 3">
                Get an overview
              </div>
              <div v-if="tour.currentStep === 4">
                Compare
              </div>
              <div v-if="tour.currentStep === 5">
                Spot your offending prefixes
              </div>
              <div v-if="tour.currentStep === 6">
                Download a list of your offending prefixes
              </div>
              <div v-if="tour.currentStep === 7">
                Get report
              </div>
              <div v-if="tour.currentStep === 8">
                Get the most of DASH
              </div>
              <div class="icon-times">
                <fa icon="times" @click="tour.skip"></fa>
              </div>
            </div>
            <div slot="content" class="content">
              <template v-if="tour.currentStep === 0">
                <p>Hi!</p>
                <p>
                  Thanks for trying out DASH and keeping your network secure.
                </p>
                <p>
                  Here are a few tips to start using your Dashboard for
                  Autonomous System Health.
                </p>
              </template>

              <template v-if="tour.currentStep === 1">
                <p>
                  Define your member account and origin AS. The dashboard will
                  tell you if our honeynet sensors have seen suspicious traffic
                  coming from your network.
                </p>
              </template>

              <template v-if="tour.currentStep === 2">
                <p>
                  Use this drop-down menu to choose the time period for which
                  you would like to see information about suspicious traffic
                  coming out of your network: 30 or 60 days.
                </p>
              </template>

              <template v-if="tour.currentStep === 3">
                <p>
                  Find the number of hits from your network, your economy and
                  your sub-region for the current period of time compared to the
                  previous period of time. You can use this to assess if the
                  situation is improving or getting worse.
                </p>
              </template>

              <template v-if="tour.currentStep === 4">
                <p>
                  Compare the daily number of hits for your network against your
                  economy or your sub-region. You can use this to assess the
                  situation of your network compared with the corresponding
                  geographic area.
                </p>
              </template>
              <template v-if="tour.currentStep === 5">
                <p>
                  Discover the prefixes in your network originating the highest
                  numbers of hits.
                </p>
              </template>
              <template v-if="tour.currentStep === 6">
                <p>
                  Download a spreadsheet containing the list of the top
                  offending prefixes and IP addresses with their corresponding
                  number of hits.
                </p>
              </template>
              <template v-if="tour.currentStep === 7">
                <p>
                  Receive recurring reports or download a report of the top
                  offending IP addresses of your network. You could use it to
                  communicate with the person responsible for the specific
                  prefixes in order for them to quickly take action.
                </p>
              </template>
              <template v-if="tour.currentStep === 8">
                <p>
                  {{ isMobile ? 'Expand' : 'Use' }} the left menu to discover
                  what to do if there is suspicious traffic seen from your
                  network, stay on top of security news, and much more.
                </p>
              </template>
            </div>
            <div slot="content" class="content"></div>

            <div slot="actions" class="actions" v-if="tour.currentStep === 0">
              <button @click="tour.skip" class="btn btn-outline-light mr-2">
                No, thanks
              </button>
              <button @click="tour.nextStep" class="btn btn-primary">
                Take Tour
              </button>
            </div>
            <div
              slot="actions"
              class="actions"
              v-else-if="tour.currentStep === 8"
            >
              <div class="mr-3">Step {{ tour.currentStep }} of 8</div>
              <button
                @click="tour.previousStep"
                class="btn btn-outline-light mr-2 btn-90"
              >
                Back
              </button>
              <button @click="tour.finish" class="btn btn-primary btn-90">
                Done
              </button>
            </div>
            <div slot="actions" class="actions" v-else>
              <div class="mr-3">Step {{ tour.currentStep }} of 8</div>
              <button
                @click="tour.previousStep"
                class="btn btn-outline-light mr-2 btn-90"
                v-if="tour.currentStep !== 1"
              >
                Back
              </button>
              <button @click="tour.nextStep" class="btn btn-primary btn-90">
                Next
              </button>
            </div>
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
const MOBILE_STEPS = [
  {
    target: '#v-step-0--mobile'
  },
  {
    target: '#v-step-1--mobile',
    params: {
      highlight: true
    }
  },
  {
    target: '#v-step-2',
    params: {
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '#v-step-3',
    params: {
      highlight: true,
      placement: 'left'
    }
  },
  {
    target: '#v-step-4',
    params: {
      highlight: true,
      placement: 'left-end'
    }
  },
  {
    target: '#v-step-5',
    params: {
      highlight: true,
      placement: 'bottom'
    }
  },
  {
    target: '#v-step-6--mobile',
    params: {
      highlight: true
    }
  },
  {
    target: '#v-step-7',
    params: {
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '.v-step-8--mobile',
    params: {
      highlight: true,
      placement: 'top'
    }
  }
];
const DESKTOP_STEPS = [
  {
    target: '#v-step-0'
  },
  {
    target: '#v-step-1',
    params: {
      highlight: true
    }
  },
  {
    target: '#v-step-2',
    params: {
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '#v-step-3',
    params: {
      highlight: true,
      placement: 'right'
    }
  },
  {
    target: '#v-step-4',
    params: {
      highlight: true,
      placement: 'right'
    }
  },
  {
    target: '#v-step-5',
    params: {
      highlight: true,
      placement: 'right'
    }
  },
  {
    target: '#v-step-6',
    params: {
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '#v-step-7',
    params: {
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '.v-step-8',
    params: {
      highlight: true,
      placement: 'right-start'
    }
  }
];
export default {
  data() {
    return {
      myCallbacks: {
        onNextStep: this.onNextStepCallback,
        onPreviousStep: this.onPreviousStepCallback,
        onFinish: this.onFinish,
        onSkip: this.onSkip
      },
      steps: []
    };
  },
  methods: {
    onSkip() {
      localStorage.setItem('welcome_tour_status', 'done');
      this.$store.dispatch('dataStore/finishWelcomeTour');
    },
    onFinish() {
      localStorage.setItem('welcome_tour_status', 'done');
      this.$store.dispatch('dataStore/finishWelcomeTour');
    },
    onNextStepCallback(currentStep) {
      if (!this.isMobile) {
        if (currentStep === 5) {
          window.scrollTo(
            0,
            document.querySelector('#v-step-5').offsetTop - 200
          );
        }
        return;
      }
      if (currentStep === 1) {
        document.querySelector('.mobile-toggle-btn').click();
      }
    },
    onPreviousStepCallback(currentStep) {
      if (!this.isMobile) {
        if (currentStep === 7) {
          window.scrollTo(
            0,
            document.querySelector('#v-step-5').offsetTop - 200
          );
        }
        return;
      }
      if (currentStep === 2) {
        document.querySelector('.mobile-toggle-btn').click();
      }
    },
    computeSteps() {
      let steps;
      if (this.$store.getters['isSmallerScreen']) {
        steps = [...MOBILE_STEPS];
      } else {
        steps = [...DESKTOP_STEPS];
      }
      this.steps = steps;
    }
  },
  mounted() {
    this.computeSteps();
  },
  destroyed() {
    if (this.$tours['myTour']) {
      this.$tours['myTour'].skip();
      this.$store.dispatch('dataStore/finishWelcomeTour');
    }
  },
  watch: {
    isMobile(value) {
      if (this.$tours['myTour']) {
        this.$tours['myTour'].skip();
        this.$store.dispatch('dataStore/finishWelcomeTour');
      }
      this.computeSteps();
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters['isSmallerScreen'];
    }
  }
};
</script>

<style lang="scss" scoped>
.v-tour {
  & /deep/ {
    .v-step[x-placement^='bottom'] .v-step__arrow {
      border-color: #023957;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
    }

    .v-step[x-placement^='top'] .v-step__arrow {
      border-color: #023957;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }

    .v-step[x-placement^='right'] .v-step__arrow {
      border-color: #023957;
      border-left-color: transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
    }

    .v-step[x-placement^='left'] .v-step__arrow {
      border-color: #023957;
      border-right-color: transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
    }
  }
  .v-step {
    background: #023957;
    padding: 0;
    max-width: 310px;
  }

  .icon-times {
    cursor: pointer;
  }

  .header {
    display: flex;
    padding: 10px;
    border-bottom: 1px solid white;
    justify-content: space-between;
    font-weight: 600;
    text-align: left;
  }
  .content {
    padding: 10px;
    text-align: left;
    p {
      color: white;
    }
  }
  .actions {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      min-width: 101px;
    }

    .btn-90 {
      min-width: 90px;
    }
  }
}
</style>
